import Button from 'components/Button/index'
import Drawer from 'components/Drawer'
import { FlexWrap, Form } from 'components/UIComponents/FormStyles'
import React from 'react'
import { useParams } from 'react-router-dom'
import AddUserForm from './Partials'

const ConfirmDrawer = ({
  form,
  confirmDrawer,
  setConfirmDrawer,
  appliedCandidatesListTrue,
  singleRoleData,
  getAppliedCandidateListTrue,
  jobId,
  candidateIds,
  setshortListDrawer,
  prefferedlocationStatus,
  currentLocationStatus,
  studentRating,
  prefferedLocations,
  selectedRows,
  corporateId,
  excandidateId,
}) => {
  const params = useParams()
  const onClose = () => {
    setConfirmDrawer(false)
    setshortListDrawer(false)
    form.resetFields()
    getAppliedCandidateListTrue({ roleId: params?.jobId })
  }

  const content = () => {
    return (
      <Form scrollToFirstError id={'addUserForm'} form={form} layout="vertical">
        <AddUserForm
          setConfirmDrawer={setConfirmDrawer}
          form={form}
          appliedCandidatesListTrue={appliedCandidatesListTrue}
          singleRoleData={singleRoleData}
          prefferedlocationStatus={prefferedlocationStatus}
          currentLocationStatus={currentLocationStatus}
          studentRating={studentRating}
          prefferedLocations={prefferedLocations}
          selectedRows={selectedRows}
          jobId={jobId}
          candidateIds={candidateIds}
          corporateId={corporateId}
          excandidateId={excandidateId}
        />
      </Form>
    )
  }

  const footer = () => {
    return (
      <FlexWrap gap="20px" right>
        <Button.Secondary text="Close" height="38px" onClick={onClose} />
      </FlexWrap>
    )
  }

  return (
    <Drawer
      width="40%"
      title={'Shortlist'}
      placement="right"
      padding="30px"
      headerpadding="16px 30px"
      closable
      onClose={onClose}
      visible={confirmDrawer}
      content={content()}
      footer={footer()}
    />
  )
}

export default ConfirmDrawer
